import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode("保存")

import { ref, unref } from 'vue';
import { ElMessage } from 'element-plus';
import { useRouter } from 'vue-router'

import { CpCreateApi } from '@/apis/counterpart/counterpart.api'
import { CounterparCreate } from '@/apis/counterpart/counterpart.type'

import Writer from './Writer.vue'


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const { push } = useRouter()

const loading = ref(false)
const writerRef = ref<ComponentRef<typeof Writer>>()

/* 保存合同数据 */
const onSaveButtonClick = () => {
    const writer = unref(writerRef);

    writer?.elFormRef?.validate(valid => {
        if (!valid) { return }

        writer.methods.setLogin(true)

        const contactList = writer?.contactRef?.expMethods.getContactList()
        const bankList = writer?.bankRef?.expMethods.getBankList()

        if (!bankList && (bankList || []).length < 1) {

            ElMessage.warning(`未设置收款银行信息`)
            return;
            
        }

        const createDto = writer.methods.getFormData() as CounterparCreate

        createDto.bank_list = bankList
        createDto.contact_list = contactList

        CpCreateApi(createDto).then((res) => {

            if (res.succeeded) {

                ElMessage({ type: 'success', showClose: true, message: '创建相对方成功', })

                push('/basics/consignee/manage')

            }
            else {

                ElMessage({ type: 'error', showClose: true, message: `创建相对方失败，原因可能是：${res.errors}`, })

            }

        }).finally(() => {

            setTimeout(() => {

                writer.methods.setLogin(false)

            }, 500);

        })
    });
};


return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _directive_loading = _resolveDirective("loading")!

  return _withDirectives((_openBlock(), _createBlock(Writer, {
    ref_key: "writerRef",
    ref: writerRef,
    titles: '创建相对方'
  }, {
    Options: _withCtx(() => [
      _createVNode(_component_el_button, {
        type: "primary",
        onClick: onSaveButtonClick
      }, {
        default: _withCtx(() => [
          _hoisted_1
        ]),
        _: 1
      })
    ]),
    _: 1
  })), [
    [_directive_loading, loading.value]
  ])
}
}

})